module.exports = __webpack_public_path__ + "img/744.c5e380ce.jpg";